import { http } from 'services/http';
import type { CreateSoldTripPDFDto, DocumentSignedUrlRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useGenerateSoldTripPdf = (tripId: number) => {
  return useMutationBase<DocumentSignedUrlRes, unknown, CreateSoldTripPDFDto>({
    mutationFn: async (variables) => {
      const res = await http.post<DocumentSignedUrlRes>(`/v1/trips/${tripId}/sold-trip/pdf`, variables);

      return res.data;
    },
  });
};
